import { Injectable } from "@angular/core";
import { ActivatedRoute, CanActivate, Router } from "@angular/router";

@Injectable()
export class ValidaTokenSusComercioService implements CanActivate {

  constructor() {}

  canActivate() {
      return true;
    }
  }
